<template>
    <div>
        <!-- Default Slot -->
        <slot :form="form"></slot>

        <!-- Content Row -->
        <div class="vx-row">
            <div class="vx-col w-full mt-6">
                <vs-input class="w-full" :label="optionalFieldLabel('Notes')"
                          v-model="form.Notes"
                          name="Notes" />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full mt-6">
                <label class="vs-input--label">{{ $t('Disclaimer') }}</label>
                <vx-card class="disclaimer" v-if="$i18n.locale === 'en'">
                  {{ user.CompanyName }} is responsible for the compliance of the specific coverage options
                  selected within the Rater with the actual purchase choices of the Proposer,
                  specifically where the Proposal Form is a separately completed and / or signed document without the help of the remote signature tool.
                  {{ user.CompanyName }} also confirms that the information contained in the Rater and the Proposal Form
                  (where this constitutes a separate document) is, to the best of its knowledge, true and complete.
                </vx-card>
                <vx-card class="disclaimer" v-if="$i18n.locale === 'it'">
                  {{ user.CompanyName }} si assume la responsabilita della rispondenza delle specifiche opzioni di copertura selezionate all’interno
                  del Preventivatore alle effettive scelte d’acquisto del Proponente - Assicurando, specificamente laddove il Modulo di
                  Proposta sia un documento compilato separatamente e/o firmato senza l’ausilio dello strumento della firma remota.
                  {{ user.CompanyName }} conferma inoltre che le informazioni contenute nell’allegato Preventivatore e nel Modulo di Proposta
                  (ove questo costituisca documento separato) sono, per quanto a sua conoscenza, veritiere e complete.
                </vx-card>
                <vx-card class="disclaimer" v-if="$i18n.locale === 'es'">
                  {{ user.CompanyName }} es responsable del cumplimiento de las opciones
                  específicas de coberturas seleccionadas en el Tarificador con las selecciones reales del Proponente,
                  especialmente donde el formulario de propuesta está completado separadamente y/o firmado sin la ayuda
                  de ninguna herramienta de firma remota. {{ user.CompanyName }}
                  también confirma que la información contenida en el Tarificador y en el formulario de propuesta
                  (cuando esto constituye un documento separado) es, a su leal saber yentender, verdadera y completa.
                </vx-card>
            </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full">
                <vs-checkbox v-model="form.Agreed"
                             name="Agreed"
                             :data-vv-as="$t('Signed')"
                             v-validate="'required: { allowFalse: false }'"
                >{{ $t('Signed') }}</vs-checkbox>
                <span class="text-danger text-sm" v-show="errors.has('Agreed')">{{ errors.first('Agreed') }}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "FirmOrderSubForm",
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
  inject: ['$validator'],
  data() {
    return {
      form: {
        Notes: '',
        Agreed: false,
      },
      disclaimer: null,
      user: null,
    }
  },
  watch: {
    form: {
      handler(newForm) {
        this.$emit('input', newForm);
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getUserData();
  },
  methods: {
    optionalFieldLabel(fieldName) {
      return this.$t(fieldName) + ' (' + this.$t('Optional') + ')';
    },
    async getUserData() {
      this.user = this.$store.getters['auth/user'];
      const { data } = await this.$api.userInformation.list();
      this.user = { ...this.user, ...data.data };
    }
  }
}
</script>

<style lang="scss">

</style>
